/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import { getPosImportStockState } from '../../../../../services/PointOfSale/PointOfSale.service'
import { TIME } from '../../../../../services/date.service'
import { useTranslation } from 'react-i18next'
import useUser from '../../../../Shared/UserProvider/useUser'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { NoImportStock } from './NoImportStock'
import { Icon, IconGroup } from 'semantic-ui-react'
import formatDate from '../../../../../helpers/formatDate'


const ImportStockCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['import-stock', user.provider.object.id],
        queryFn: () => getPosImportStockState(user.provider.object.id),
        staleTime: TIME.HOUR_IN_MS,
    })

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        if (isLoading || !data) {
            return 'grey'
        }

        return data.state ? '#22c55e' : '#dc2626'
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};
            .card-content {
                width: 265px;
                height: 110px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : !data ? <NoImportStock /> : (
            <CardContent
              css={css`
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  flex-direction: column;
                  padding: 1rem;
                  width: 100%;
              `}
            >
                <div
                  css={css`
                        display: flex;
                        align-items: center;
                        column-gap: .5rem;
                        margin-bottom: 1rem;
                    `}
                >
                    <IconGroup size="big">
                        <Icon color="grey" name="plug"/>
                        <Icon
                          corner
                          name={data.state ? 'checkmark' : 'ban'}
                          color={data.state ? 'green' : 'red'}
                        />
                    </IconGroup>
                    <p
                      css={css`
                            margin-right: .5rem;
                            font-weight: bold;
                        `}>
                        {t('import_stock.stocks', {name: data?.name})}
                    </p>
                </div>
                {data.state?.syncAt &&
                  <p>
                      {t('import_stock.state.last_sync')}<br />
                      <b>{formatDate(data.state.syncAt)}</b>
                  </p>
                }
            </CardContent>
          )}
      </Card>
    )
}

export { ImportStockCard }
